<bw-modal-legacy *ngIf="visible" modalWidth="medium" [showCloseButton]="true" (closeModal)="handleClick(false)">
  <typography-legacy title-medium color="var(--primary-text)" class="mb-sm">{{ 'PROGRESS_STEP_CONNECT_CREDIT' | translate }}</typography-legacy>
  <section class="body" [brightsideWebFb]="{ event_name: 'credit_details_shown' }">
    <bw-paragraph-legacy>
      <typography-legacy text-large-regular color="var(--secondary-text)">
        <div [innerHTML]="'CREDIT_WELCOME_DESC' | translate"></div>
      </typography-legacy>
    </bw-paragraph-legacy>
  </section>
  <footer class="footer">
    <div class="flex-row row-reverse">
      <button
        bw-button-legacy
        [brightsideWebFb]="{ event_name: 'credit_details_tapped', action: 'click' }"
        (click)="results.emit(true)"
      >
        {{ 'BUTTON_CONTINUE' | translate }}
      </button>
    </div>
  </footer>
</bw-modal-legacy>
